import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

const FooterCopyrightContainer = styled((props: any) => <StyledGrid {...props} />)`
  ${({ theme }) => `
  .contenedor_footer_copyright {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 10px;
  }

  .contenedor_footer_copyright_links {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
  }

  .footer_copyright_texto {
    font-family: Inter;
    font-size: 12px;
    color: #767677;
    margin: 0;
  }

  .footer_copyright_link {
    font-family: Inter;
    font-size: 12px;
    color: #767677;
  }

  //VERSION DESKTOP
  .contenedor_footer_copyright_links_desktop {
    display: flex;
    justify-content: space-around;
    align-items: start;
    gap: 10px;
  }

  .contenedor_footer_copyright_desktop {
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  a.footer_copyright_link_desktop {
    font-family: Inter;
    font-size: 12px !important;
    color: #263645 !important;
  }

  p.footer_copyright_texto_desktop {
    font-family: Inter;
    font-size: 12px !important;
    color: #767677 !important;
    margin: 0px;
  }

`}
`;

export const FooterCopyright = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  return (
    <FooterCopyrightContainer>
      <div className={isMobile ? "contenedor_footer_copyright" : "contenedor_footer_copyright_desktop"}>
        <div className={isMobile ? "contenedor_footer_copyright_links" : "contenedor_footer_copyright_links_desktop"}>
          <Link to="/" className={isMobile ? "footer_copyright_link" : "footer_copyright_link_desktop"}>
            {t("Footer.Onboard.Copyright.PrivacyPolicy")}
          </Link>
          <Link to="/" className={isMobile ? "footer_copyright_link" : "footer_copyright_link_desktop"}>
            {t("Footer.Onboard.Copyright.TermsAndConditions")}
          </Link>
          <Link to="/" className={isMobile ? "footer_copyright_link" : "footer_copyright_link_desktop"}>
            {t("Footer.Onboard.Copyright.CookiesPolicy")}
          </Link>
        </div>
        <div className="contenedor_footer_copyright_texto">
          <p className={isMobile ? "footer_copyright_texto" : "footer_copyright_texto_desktop"}>
            {t("Footer.Onboard.Copyright.Copyright")}
          </p>
        </div>
      </div>
    </FooterCopyrightContainer>
  );
};
